import React from 'react'
import { Col, List, Row, Typography } from 'antd'
import CustomList from '../../../components/Shared/CustomList'
import CustomVideo from '../../../components/Shared/CustomVideo'
import { GeneralTitle } from '../../../components/Shared'

const { Title, Paragraph } = Typography

const services = [
	'Business Services',
	'Project Management',
	'Virtual Assistant',
	'Data Entry',
	'Lead Generation',
	'Market Research'
]

const Business = () => {
	return (
		<>
			<GeneralTitle>Business</GeneralTitle>

			<Row gutter={[20, 20]} justify="space-between" align="middle">
				<Col xs={24} sm={24} md={14} lg={14}>
					<Title level={4}>
						Your business = your passion. Outsource smaller tasks so
						you can focus on growth
					</Title>
					<Paragraph>
						Webackit offers cost-effective IT outsourcing solutions
						designed to work for every type of business.
					</Paragraph>
					<Paragraph>
						Increase your revenue and traffic growth by outsourcing
						all your daily tasks that can be automated.
					</Paragraph>
					<Paragraph>
						Outsource your market research or data entry and speed
						up your product launch in no time with webackit.com
					</Paragraph>
					<CustomList
						dataSource={services}
						renderItem={(item) => <List.Item>{item}</List.Item>}
					/>
				</Col>
				<Col xs={24} sm={24} md={10} lg={10}>
					<img
						width="100%"
						src={`${process.env.PUBLIC_URL}/branding/webackit-services-diagram-business.svg`}
						alt="WordPress Services Diagram"
					/>
				</Col>
			</Row>

			<CustomVideo
				src="https://webackit.com/videos/webackit-conquering-small-task-overload.mp4"
				type="video/mp4"
				styleProps={{
					width: '100%'
				}}
			/>
		</>
	)
}

export default Business
